import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MedPaginationModule} from "@med-ui/med-pagination/med-pagination.module";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {QuarantineApiService} from "@app/quarantine/services/quarantine.api.service";
import {FilterModule} from "@app/filter/filter.module";
import {
  QuarantineDocumentPlacement,
  SelectedMedicineMedicalDevicesInterface
} from "@app/quarantine/intrfaces/quarantine.interface";
import {catchError, switchMap} from "rxjs";
import {ToastService} from "@app/toast/toast.service";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";

@Component({
  selector: 'app-edit-quarantine-placement-table',
  templateUrl: './edit-quarantine-placement-table.component.html',
  standalone: true,
  imports: [
    MedPaginationModule,
    DatePipe,
    NgIf,
    NgForOf,
    FilterModule,
    LoadingAnimationComponent
  ],
  styleUrls: ['./edit-quarantine-placement-table.component.scss']
})
export class EditQuarantinePlacementTableComponent implements OnInit {
  @Output() onRefreshList = new EventEmitter<SelectedMedicineMedicalDevicesInterface[]>();
  @Input() documentId: any;
  @Input() isRemoval: boolean = false;
  
  @Input()
  set isRefreshing(data: boolean) {
    if (data) {
      this.refreshList()
    }
  }
  
  quarantinePlacement: QuarantineDocumentPlacement | undefined = history.state.quarantinePlacement;
  
  showRefreshButton: boolean = false;
  isLoading = true;
  
  itemsPerPage = 20;
  currentPage = 1;
  totalPages = 1;
  
  products :any= []
  totalElements = 0;
  
  filters = {
    institutionIds: []
  }
  
  @ViewChild('tableHolder', {static: true}) tableHolder!: ElementRef;
  
  constructor(
      protected quarantineApiService: QuarantineApiService,
      protected toastService: ToastService,
  ) { }
  
  ngOnInit(): void {
    this.showRefreshButton = this.quarantinePlacement?.documentStatus === 'DRAFT' && this.quarantinePlacement?.transactionType === 'QUARANTINE_PLACEMENT';
    
    this.getProducts();
  }
  
  onPageChange(page: number) {
    this.currentPage = page;
    this.getProducts();
  }
  
  applyFilters(data: any) {
    this.filters.institutionIds = data.payload;
    this.currentPage = 1
    this.getProducts();
  }
  
  getProducts() {
    if (!this.documentId) {
      return;
    }
    
    let params = {
      page: this.currentPage - 1,
      size: this.itemsPerPage,
    }
    this.isLoading = true;
    
    if (this.filters.institutionIds.length) {
      // @ts-ignore
      params['institutionIds'] = this.filters.institutionIds
    }
    
    if (!this.isRemoval) {
      this.quarantineApiService.getQuarantineDocument(this.documentId, params)
          .subscribe((data)=> {
            this.products = data.content;
            this.totalElements = data.totalElements;
            this.totalPages = data.totalPages;
            this.isLoading = false;
          });
    } else {
      this.quarantineApiService.getQuarantineDocumentRemoval(this.documentId, params)
          .subscribe((data)=> {
            this.products = data.content;
            this.totalElements = data.totalElements;
            this.totalPages = data.totalPages;
            this.isLoading = false;
          });
    }
  }
  
  refreshList() {
    this.isLoading = true;
    this.quarantineApiService.refreshTransactionPlacement(this.quarantinePlacement?.id)
        .pipe(
            switchMap((data: any) => {
              this.currentPage = 1;
              let params = {
                page: this.currentPage - 1,
                size: this.itemsPerPage,
              }
              return this.quarantineApiService.getQuarantineDocument(this.documentId, params)
            }),
            catchError(err => {
              console.log(err);
              if (err && err.error && err.error.messages && err.error.messages.length) {
                this.toastService.showError(err.error.messages[1]);
              } else {
                this.toastService.showError();
              }
              this.isLoading = false;
              return err;
    })
        )
        .subscribe((data)=> {
          this.toastService.showSuccess('Оновлено транзакції для документу розміщення в карантин');
          this.products = data.content;
          this.totalElements = data.totalElements;
          this.totalPages = data.totalPages;
          this.onRefreshList.emit(this.products.map((el: any) => ({
            tradeName:  el.medicineMedicalDevice.tradeName,
            series:  el.medicineMedicalDevice.series
          })));
          this.isLoading = false;
        });
  }

}
